import api from '@pray/shared/utils/api';

export type RetryLeadValidationParams = {
  artistId: string;
};

export type RetryLeadValidationResponse = {
  data: {
    artist_id: string;
    pending_count?: number;
    status: 'initiated' | 'skipped';
    message?: string;
    skipped_reason?: string;
  };
};

export async function retryLeadValidation({
  artistId,
}: RetryLeadValidationParams): Promise<RetryLeadValidationResponse> {
  const url = `/web/studio/system-check/lead-validation/artist/${artistId}/retry`;
  // The HTTP body wraps the serializer payload in `{ data }`, and the
  // serializer itself emits `{ data: { ... } }` — so we double-unwrap to
  // reach the `{ artist_id, status, ... }` envelope. Matches the GET path.
  const response = await api.executePostRequest<{ data: RetryLeadValidationResponse }>(url);

  return response.data.data;
}
